import {
  fetchCouponList,
  fetchGetActiveCoupons,
  fetchGetCouponBundle,
  fetchGetCouponHold,
  fetchReceiveCouponBundle,
  fetchUserCouponDetail,
} from '@/services';
import type { AnyObj, AnyObjOrNull } from '@/types';
import { defineStore } from 'pinia';

interface State {
  /** 未使用的优惠券列表数据 */
  unusedCouponList: AnyObj[];
  /** 未使用的等级会员专属优惠券列表数据 */
  unusedMembershipLevelCouponList: AnyObj[];
  /** 用户已获取的优惠券列表数据（包含可用、不可用） */
  userReceiveCoupons: AnyObjOrNull;
  /** 已使用、失效的优惠券列表数据 */
  invalidCouponList: AnyObj[];
  /** 已使用、失效的等级会员专属优惠券列表数据 */
  invalidMembershipLevelCouponList: AnyObj[];
  /** 优惠券详情数据 */
  couponDetail: AnyObjOrNull;
  /** 用户的优惠券数据 */
  userCoupon: AnyObjOrNull;
  /** 适用商品数据 */
  suitCommodityList: AnyObj[];
  /** 优惠券渲染配置信息缓存 */
  couponConfigCache: AnyObjOrNull;
  /** 优惠券持有信息 */
  couponHold: AnyObjOrNull;
  couponBundleData: AnyObject;
  /** 优惠券礼包数据 */
  couponBundleList: AnyObject[];
  /** 用户已经领取的优惠券礼包数据 */
  reciiveCouponBundleList: AnyObj[];
}

export const useCouponStore = defineStore('coupon', {
  state: (): State => ({
    unusedCouponList: [],
    unusedMembershipLevelCouponList: [],
    userReceiveCoupons: null,
    invalidCouponList: [],
    invalidMembershipLevelCouponList: [],
    couponDetail: null,
    userCoupon: null,
    suitCommodityList: [],
    couponConfigCache: null,
    couponHold: null,
    couponBundleData: null,
    couponBundleList: [],
    reciiveCouponBundleList: [],
  }),

  getters: {
    // 用户可用优惠券列表数据
    receiveAvailableCouponList(state) {
      return state.userReceiveCoupons?.availableCoupons ?? [];
    },
    // 用户不可用优惠券列表数据
    receiveNotAvailableCouponList(state) {
      return state.userReceiveCoupons?.couponsAreNotAvailable ?? [];
    },
    // 用户不可用的兑换券列表数据
    lackOfExchangeGoodsCouponList(state) {
      const list = state.userReceiveCoupons?.lackOfExchangeGoodsCoupons ?? [];
      return list.map((it: AnyObject) => {
        it._unExchange = true;
        return it;
      });
    },
    isShareable(state) {
      if (state.couponDetail?.isShareable === false) {
        return false;
      }
      return true;
    },
  },

  actions: {
    async getUnusedCouponList(refresh?: boolean) {
      if (!this.unusedCouponList.length || refresh) {
        this.unusedCouponList = await fetchCouponList(true);
      }
      return this.unusedCouponList;
    },
    async getUnusedMembershipLevelCouponList(refresh?: boolean, ids: Array<string> = []) {
      if (!this.unusedMembershipLevelCouponList.length || refresh) {
        this.unusedMembershipLevelCouponList = await fetchCouponList(true, ids);
      }
      return this.unusedMembershipLevelCouponList;
    },
    async getInvalidCouponList(refresh?: boolean) {
      if (!this.invalidCouponList.length || refresh) {
        this.invalidCouponList = await fetchCouponList(false);
      }
      return this.invalidCouponList;
    },
    async getInvalidMembershipLevelCouponList(refresh?: boolean, ids: Array<string> = []) {
      if (!this.invalidMembershipLevelCouponList.length || refresh) {
        this.invalidMembershipLevelCouponList = await fetchCouponList(false, ids);
      }
      return this.invalidMembershipLevelCouponList;
    },
    async getUserCouponDetail(userCouponId: string, refresh?: boolean, removeNewTag = false) {
      if (!this.couponDetail || refresh) {
        const data = await fetchUserCouponDetail(userCouponId, removeNewTag);
        if (data) {
          this.couponDetail = data.coupon;
          this.userCoupon = data;
        }
      }
      console.log(`用户优惠券详情：`, this.couponDetail);

      return this.couponDetail;
    },
    async getUserReceiveCouponList(orderId: string, refresh?: boolean) {
      if (!this.userReceiveCoupons?.length || refresh) {
        this.userReceiveCoupons = await fetchGetActiveCoupons(orderId);
      }
      return this.userReceiveCoupons;
    },
    async getCouponHold(couponId: string) {
      if (couponId) {
        const data = await fetchGetCouponHold(couponId);
        if (data) {
          this.couponDetail = data?.coupon;
          this.couponHold = data;
        }
        console.log(`用户优惠券持有：`, this.couponHold);
        return this.couponHold;
      }
    },
    async getCouponBundleList(couponBundleId: string, refresh?: boolean) {
      if (!this.couponBundleList?.length || refresh) {
        const data = await fetchGetCouponBundle(couponBundleId);
        console.log(`fetchGetCouponBundle`, data);
        if (data) {
          this.couponBundleList = data;
        }
      }
      return this.couponBundleList;
    },
    async getCouponBundleData(couponBundleId: string, refresh?: boolean) {
      if (!this.couponBundleData?.length || refresh) {
        const data = await fetchGetCouponBundle(couponBundleId);
        if (data) {
          this.couponBundleData = data;
        }
      }
      return this.couponBundleData;
    },
    async getReceiveCouponBundleList(couponBundleId: string) {
      try {
        if (couponBundleId) {
          const data = await fetchReceiveCouponBundle(couponBundleId);
          this.reciiveCouponBundleList = data;
          return this.reciiveCouponBundleList;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
});
